<template>
  <div>
    <!--提示语-->
    <div style="padding: 10px;color: #d9d9d9">{{ $t('CargoMsg.Cargo_OcrTip2') }}</div>
    <div class="result-form-se">
      <div :style="{cursor:'pointer',width: '100%'}">
        <!--ocr识别字段-header-->
        <div class="row" style="position: relative;">
          <div class="item1" style="font-weight: bold;color: white;background-color: #3f3f3f">
            <span>{{ $t('CargoMsg.Cargo_FieldName') }}</span>
          </div>
          <span
            v-if="showBookRecognitionResults"
            style="position: absolute;left: 105px;top: 6px; padding: 2px;background-color: white;cursor: pointer"
            @click="showBookRecognitionResults=false"
          >{{ $t('CargoMsg.Cargo_PackUp') }}</span>
          <span
            v-else
            style="position: absolute;left: 105px;top: 6px; padding: 2px;background-color: white;cursor: pointer"
            @click="showBookRecognitionResults=true"
          >{{ $t('CargoMsg.Cargo_ExpandAll') }}</span>
          <div v-if="showBookRecognitionResults" class="item2" style="font-weight: bold;color: white;background-color: #3f3f3f">{{ $t('CargoMsg.Cargo_BookRecognitionResults') }}</div>
          <div class="item3" style="font-weight: bold;color: white;background-color: #abd08e">{{ $t('CargoMsg.Cargo_ConfirmedBusinessData') }}</div>
        </div>
        <!--ocr识别字段-content-->
        <div v-if="currentOcrRecognitionFields && currentOcrRecognitionFields.length > 0">
          <div v-for="item in currentOcrRecognitionFields" :key="item.code">
            <!--MBL-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_BILL_NO.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_BLNo') }} </div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-input v-model="job.billNo" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
            </div>
            <!--提单形式-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_ORDER_TYPE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.BLForm') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-select
                v-model="job.orderType"
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                :placeholder="!job.orderType && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                :class="!job.orderType && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                no="orderType"
                clearable
                @clear="clear(item)"
              >
                <el-option
                  v-for="(item,index) in blModeList"
                  :key="index"
                  :label="item.name"
                  :value="item.serialNumber"
                />
              </el-select>
            </div>
            <!--正本份数-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_BL_NUMBER.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_NumberOfOriginalCopies') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-input v-model="job.blNumber" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
            </div>
            <!--发货人-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_SHIPPER.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Message.Shipper') }}</div>
              <!--            <div class="item2" v-if="showBookRecognitionResults">{{ resultJson[item.code] }}</div>-->
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" />
              <el-input v-model="job.shipper" :rows="6" type="textarea" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
            </div>
            <!--收货人-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CONSIGNEE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Message.Consignee') }}</div>
              <!--            <div class="item2" v-if="showBookRecognitionResults">{{ resultJson[item.code] }}</div>-->
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" />
              <el-input v-model="job.consignee" :rows="6" type="textarea" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
            </div>
            <!--通知人-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_NOTIFY.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Message.Notify') }}</div>
              <!--            <div class="item2" v-if="showBookRecognitionResults">{{ resultJson[item.code] }}</div>-->
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" />
              <el-input v-model="job.notify" :rows="6" type="textarea" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
            </div>
            <!-- 整拼类型  -->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CONTAINER_LOAD_TYPE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_FLCLType') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <cargo-advance-select
                filterable
                no="containerLoadType"
                clearable
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                :select-type="selectTypeNames.local_cache_ImportConstants$_cargoTypeInputList"
                callback-method-type="value"
                :default-value="job.containerLoadType"
                :tag-name="$store.getters.language==='zh'?'chineseName':'englishName'"
                tag-value="code"
                :callback-params="{key:'containerLoadType'}"
                @parentCallBack="obj=>pm.qCargoType_Change(obj)"
              />
            </div>
            <!--船公司-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CARRIER.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.ShippingCompany') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <cargo-company-select
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
                :default-value="job.carrierId||''"
                :placeholder="!job.carrierId && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                :class="!job.carrierId && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                @clear="clear(item)"
                @change="p=>{job.carrierId=p.value} "
              />
            </div>
            <!--船名-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_VESSEL.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Payment.vessel') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <!--              <el-input v-model="job.vessel" class="item3" :style="{ borderColor: getValueBorderColor(item) }" @focus="handleFocus('vessel')" />-->
              <cargo-advance-select
                no="vessel"
                class="item3"
                :select-type="selectTypeNames.static_data_Vessel"
                :cache="false"
                filterable
                :allow-create="true"
                :default-value="job.vessel"
                :static-options="vesselList"
                :style="{ borderColor: getValueBorderColor(item) }"
                @parentCallBack="p=>{onVesselSelectionChange(p)}"
              />
            </div>
            <!--航次-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_VOYAGE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Payment.voyage') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <div style="display: flex;justify-content: space-between" class="item3">
                <el-input v-model="job.voyageFlight" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
                <el-button v-if="showChooseShippingSchedulesBtn" type="primary" style="background-color: #169bd5" @click="btnVayageShowHandle">{{ $t('CargoMsg.Cargo_ChooseShippingSchedules') }}</el-button>
              </div>
            </div>
            <!--开航日期-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_ETD.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('queryJob.dateOfDeparture') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-date-picker
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                :value="job.etd"
                type="date"
                value-format="yyyy-MM-dd"
                @input="etdChange"
              />
            </div>
            <!--运输条款-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_FREIGHT_TERM.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.TransportationClause') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <cargo-advance-select
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                no="freightTerm"
                :select-type="selectTypeNames.basic_data_ShippingTerm"
                filterable
                clearable
                :default-value="job.freightTerm"
                :placeholder="!job.freightTerm && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                :class="!job.freightTerm && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                @clear="clear(item)"
                @parentCallBack="p=>{job.freightTerm=p.value}"
              />
            </div>
            <!--运费条款-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_PAYMENT_TERM.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.FreightTerm') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <cargo-advance-select
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                filterable
                clearable
                :default-value="job.paymentTermMBL"
                :placeholder="!job.paymentTermMBL && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                :class="!job.paymentTermMBL && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                @clear="clear(item)"
                @parentCallBack="p=>{
                  job.paymentTermMBL=p.value;
                }"
              />
            </div>
            <!--箱型箱量-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CONTAINER_INFOS.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_CartonQuantity') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <div class="item3" :style="{ borderColor: getValueBorderColor(item) }" style="overflow-y: auto;">
                <div style="display: flex">
                  <div style="display: flex;flex-direction: column;max-height: 200px;">
                    <div v-for="(item,index) in job.seaEQ" :key="index">
                      <div style="display: flex">
                        <div style="width: 49%">
                          <el-input-number v-model="item.eqQuantity" :controls="false" class="item3-1" no="eqQuantity" style="width: 40px;" />
                          <span style="margin-left:5px">X</span>
                        </div>
                        <div style="display:flex;">
                          <cargo-advance-select
                            class="item3-1"
                            no="eqSize"
                            :select-type="selectTypeNames.local_cache_EQSize"
                            :fields="['code']"
                            filterable
                            :placeholder="' '"
                            :show-copy="false"
                            :default-value="item.eqSize"
                            style="width: 60px;margin-left:5px"
                            tag-name="code"
                            @parentCallBack="p=>{changeSizeCallBack(item, p)}"
                          />
                          <cargo-advance-select
                            class="item3-1"
                            no="eqType"
                            :select-type="selectTypeNames.basic_data_EQType"
                            :fields="['code']"
                            filterable
                            :placeholder="' '"
                            :show-copy="false"
                            :default-value="item.eqType"
                            style="width: 60px;margin-left:5px"
                            tag-name="code"
                            @parentCallBack="p=>{changeTypeCallBack(item, p)}"
                          />
                        </div>
                        <div style="color: #1398f1; margin-left:5px;font-size:25px;cursor:pointer" @click="addSeaEQ">+</div>
                        <div style="color: #1398f1; margin-left:5px;font-size:25px;cursor:pointer" @click="deleteSeaEQ(index)">-</div>
                      </div>
                    </div>
                  </div>
                  <div v-if="!job.seaEQ || job.seaEQ.length === 0" style="color: #1398f1; margin-top: 10px;margin-left:5px;cursor:pointer" @click="addSeaEQ">{{ $t('CargoMsg.Cargo_Add') }}</div>
                </div>
              </div>
            </div>
            <!--贸易条款-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_INCO_TERM.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('queryJob.IncoTerm') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <cargo-advance-select
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                no="incoTerm"
                :select-type="selectTypeNames.basic_data_IncoTerm"
                filterable
                clearable
                :default-value="job.incoTerm"
                :placeholder="!job.incoTerm && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                :class="!job.incoTerm && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                @clear="clear(item)"
                @parentCallBack="p=>{job.incoTerm=p.value;}"
              />
            </div>
            <!--主单付款地点-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_PAYMENT_PLACE_BL.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.PlaceOfPayment') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-input v-model="job.paymentPlaceBL" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
            </div>
            <!--签发地点-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_TD_SIGN_PLACE_BL.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.PlaceOfIssue') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-input v-model="job.signPlaceBL" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
            </div>
            <!--签发日期-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_TD_SIGN_DATE_BL.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.DateOfIssue') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-date-picker
                class="item3"
                :class="{ 'input-red': item.redColor }"
                :value="job.signDateBL"
                type="date"
                value-format="yyyy-MM-dd"
                @input="value => {job.signDateBL=value}"
              />
            </div>
            <!--HS编号-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_HS_CODE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ 'HSCode' }}</div>
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" />
              <el-input v-model="job.hsCode" :rows="6" type="textarea" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
            </div>
            <!--发货地-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_DISPATCHING_PLACE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.PlaceOfReceipt') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-input v-model="job.dispatchingPlace" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
            </div>
            <!--起运港-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_LOADING_PORT_CODE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Payment.portOfLoading') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <cargo-advance-select
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                no="englishName"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="job.loadingPortCode"
                tag-name="englishName"
                :placeholder="!job.loadingPortCode && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                :class="!job.loadingPortCode && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                @clear="clear(item)"
                @parentCallBack="p=>{pm.changeLoadingPortCode(p);pm.checkVesselLine();}"
              />
            </div>
            <!--卸货港-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_DISCHARGING_PORT_CODE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('queryJob.dischargingPortCode') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <cargo-advance-select
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                no="dischargingPortCode"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="job.dischargingPortCode"
                :placeholder="!job.dischargingPortCode && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                :class="!job.dischargingPortCode && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                @clear="clear(item)"
                @parentCallBack="p=>{ job.dischargingPortCode = p.value; pm.dischargingPortCodeChange(p.value,job.carrierId);}"
              />
            </div>
            <!--交货地-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_DESTINATION_PORT_CODE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('queryJob.placeOfDelivery') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <cargo-advance-select
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                no="destinationPortCode"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="job.destinationPortCode"
                :placeholder="!job.destinationPortCode && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                :class="!job.destinationPortCode && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                @clear="clear(item)"
                @parentCallBack="p=>{job.destinationPortCode=p.value}"
              />
            </div>
            <!--件数-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_QUANTITY.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Quantity') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-input-number v-model="job.quantityContract" :controls="false" class="item3" :style="{ borderColor: getValueBorderColor(item), textAlign: 'left' }" no="quantityContract" />
            </div>
            <!--包装-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_PACKING.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Package') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <cargo-packing-select
                no="packing"
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                :default-value="job.packing"
                :placeholder="!job.packing && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                :class="!job.packing && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                @clear="clear(item)"
                @change="p=>{job.packing=p.value;}"
              />
            </div>
            <!--小件件数-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_INSIDE_QUANTITY.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Pieces2') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-input-number v-model="job.insideQuantity" :controls="false" class="item3" :style="{ borderColor: getValueBorderColor(item), textAlign: 'left' }" no="insideQuantity" />
            </div>
            <!--小件包装-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_INSIDE_PACKING.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.PiecesType2') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <cargo-packing-select
                no="insidePacking"
                class="item3"
                :style="{ borderColor: getValueBorderColor(item) }"
                :default-value="job.insidePacking"
                :placeholder="!job.insidePacking && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                :class="!job.insidePacking && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                @clear="clear(item)"
                @change="p=>{job.insidePacking=p.value;}"
              />
            </div>
            <!--毛重-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_GROSS_WEIGHT.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Weight') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-input-number v-model="job.weightContract" :precision="3" :controls="false" class="item3" :style="{ borderColor: getValueBorderColor(item), textAlign: 'left' }" no="weightContract" />
            </div>
            <!--体积-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CUBAGE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Cubage') }}</div>
              <div v-if="showBookRecognitionResults" class="item2">{{ resultJson[item.code] }}</div>
              <el-input-number v-model="job.cubageContract" :precision="3" :controls="false" class="item3" :style="{ borderColor: getValueBorderColor(item), textAlign: 'left' }" no="cubageContract" />
            </div>
            <!--唛头-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_MARK.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Marks') }}</div>
              <!--            <div class="item2" v-if="showBookRecognitionResults">{{ resultJson[item.code] }}</div>-->
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" />
              <el-input v-model="job.mark" :rows="6" type="textarea" class="item3" :style="{ borderColor: getValueBorderColor(item) }" no="mark" />
            </div>
            <!--品名-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_GOOD_NAME.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Pricing.Goods') }}</div>
              <!--            <div class="item2" v-if="showBookRecognitionResults">{{ resultJson[item.code] }}</div>-->
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" />
              <el-input v-model="job.cargoEnglishName" :rows="6" type="textarea" :class="job.ifContainSensitiveWord===true ? 'color-yellow' : ''" :style="{borderColor: getValueBorderColor(item)}" class="item3" no="cargoEnglishName" />
            </div>
            <!--备注-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_REMARKS.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Payment.remarks') }}</div>
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="5" type="textarea" class="item2" />
              <el-input v-model="job.remarks" :rows="5" type="textarea" class="item3" :style="{ borderColor: getValueBorderColor(item) }" />
            </div>
            <div v-if="item.code === SystemConstants.OCR_FIELD_CONTAINER_DATA.code" class="row" @click="handleFocus(item.code)">
              <div style="display: block; width: 100%; position: relative;">
                <span style="position: absolute;top: 6px; padding: 2px;background-color: #169bd5;cursor: pointer; color: #169bd5">{{ '.' }}</span>
                <div style="padding: 10px">{{ $t('CargoMsg.Cargo_ContainerInfo2') }}</div>
                <el-button no="26" type="primary" @click="addContainer">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
                <el-button no="27" type="danger" @click="deleteContainer">{{ $t('CargoMsg.Cargo_OrderDelete') }}</el-button>
                <div style="width: 100%;padding-top: 5px">
                  <cargo-ag-grid
                    :grid-options="gridOptions"
                    :column-defs="columnDefs"
                    :row-data="job.container"
                    style="width:100%;height:200px;"
                    @gridReady="params=>{gridApi=params.api}"
                  />
                  <div style="padding-top: 10px" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--字段校验弹窗-->
    <el-dialog
      no="fieldValidDialog"
      :visible.sync="fieldValidDialog.visible"
      :title="$t('Message.WarmReminder')"
      width="630px"
      append-to-body
    >
      <div v-for="(fieldValidResultByBook,index) in fieldValidDialog.fieldValidResults" :key="index">
        <div>{{ $t('CargoMsg.Cargo_Book') + (fieldValidResultByBook.index + 1) }}</div>
        <el-table
          :data="fieldValidResultByBook.data"
          style="width: 100%"
        >
          <el-table-column
            prop="fieldName"
            :label="$t('CargoMsg.Cargo_FieldName')"
            width="180"
          />
          <el-table-column
            prop="exceptionReason"
            :label="$t('CargoMsg.Cargo_ErrorCause')"
            width="400"
          />
        </el-table>
      </div>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="fieldValidDialog.visible = false">{{ $t('Message.GotIt') }}</el-button>
      </div>
    </el-dialog>
    <!--船期选择器-->
    <shipping-schedule-dialog
      ref="voyageShowDialog"
      append-to-body
      :visible.sync="voyageShowDialog"
      :callback="callbackShippingScheduleHanle"
    />
  </div>
</template>

<script>
import { cache, cacheName } from '@/utils/cacheManager'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import CargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import ColumnUtils from '@/utils/ColumnUtils'
import { getOcrList } from '@/api/ocrSet'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import {
  BUSINESS_MARK_1,
  OCR_FIELD_IF_REQUIRED_SAVE_JOB,
  OCR_FIELD_MAP,
  SENDING_1,
  SI,
  UPLOAD_STATUS_COMPLETE_ORDER
} from '@/class/cargo/model/parameters/SystemConstants'
import StrUtils from '@/utils/StrUtils'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { deepClone, formatNumberToThousands, getUuid } from '@/utils'
import { getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as BlModeType from '@/class/cargo/model/parameters/BlModeType'
import DateUtils from '@/utils/dateUtils'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import { _cargoTypeInputList, CARGOTYPE_GENERAL } from '@/class/cargo/model/parameters/ImportConstants'
import { Company } from '@/class/model/mdm/Company'
import { namePrefixMatch } from '@/api/company'
import { isNumber } from '@/utils/validate'
import { CONVERSION_HC } from '@/class/cargo/model/parameters/EqType'
import { loadSpecificBasicInfo } from '@/api/cache'
import shippingScheduleDialog from '@/components/Cargo/Job/shippingScheduleDialog.vue'
import { queryShippingSchedule } from '@/api/voyage'
import { BookingWorkspaceContext } from '@/views/cargo/v0/SeaImport/components/SiBooking/bookingWorkspaceContext'
import { BasicTabHP } from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/basicTabHP'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { isContractExpiredForbidCreateJobs } from '@/api/partner/contract'
import soNoInput from '@/components/Cargo/Job/soNoInput.vue'
import OcrUtils from '@/utils/OcrUtils'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { EQ_SIZES } from '@/class/cargo/model/parameters/EQSize'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index.vue'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index.vue'
import { ensureExecuteSuccess } from '@/utils/commonUtil'

export default {
  name: 'ResultFormSiTd',
  components: {
    soNoInput, CargoRichTextarea, AutoNumberInput, CargoUserSelect, CargoAdvanceSelect,
    CargoPackingSelect, cargoCompanySelect, cargoOfficeSelect, cargoDepartmentSelect, shippingScheduleDialog },
  props: {
    details: {
      type: Object,
      default: () => ({})
    },
    index: { type: Number, default: 0 },
    resultArray: { type: Array, default: () => [] },
    source: { // 来源【0-海出 1-远程订舱-海运】
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      context: new BookingWorkspaceContext(),
      pm: new BasicTabHP(this),
      CargoSource,
      JobUtils,
      resultJson: {},
      SystemConstants,
      SeaExportConstants,
      ColumnUtils,
      eqSizes: EQ_SIZES,
      eqTypes: [],
      selectTypeNames: TYPE_NAMES,
      useCase: SENDING_1.code, // 0 海运出口 1 海进提单
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoHalfWord: false,
          autoUppercase: false
        }
      },
      // otherField: {},
      expressList: [],
      mapperTexts: [],
      port: new Map(),
      carrier: new Map(),
      orderType: new Map(),
      loadType: new Map(),
      shippingTerm: new Map(),
      paymentTerm: new Map(),
      incoTerm: new Map(),
      eq: new Map(),
      customer: new Map(),
      packing: new Map(),
      blModeList: [
        { serialNumber: 1, code: 'ORIGINAL', name: 'ORIGINAL', localName: this.$t('SeaExport.OriginalNormal') },
        { serialNumber: 2, code: 'SURRENDERED', name: 'SURRENDERED', localName: this.$t('SeaExport.TelexRelease') },
        { serialNumber: 3, code: 'SEA WAYBILL', name: 'SEA WAYBILL', localName: this.$t('SeaExport.TelexRelease') }
      ],
      shippingCompanySpecificCodeInvisible: false,
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        // 行勾选事件
        onRowSelected: (event) => {
          this.selectedRows = event.api.getSelectedRows()
          const selectedUuids = new Set(this.selectedRows.map(row => row.uuid))

          for (const data of this.job.container) {
            data.selected = selectedUuids.has(data.uuid)
          }
        },
        frameworkComponents: {
          CargoAgGridCommonInputEditor,
          CargoAgGridAdvanceSelectEditor
        }
      },
      job: {
        shipperLine1: '',
        shipperLine2: '',
        shipperLine3: '',
        shipperLine4: '',
        shipperLine5: '',
        shipperLine6: '',
        shipperLine7: '',
        consigneeLine1: '',
        consigneeLine2: '',
        consigneeLine3: '',
        consigneeLine4: '',
        consigneeLine5: '',
        consigneeLine6: '',
        consigneeLine7: '',
        notifyLine1: '',
        notifyLine2: '',
        notifyLine3: '',
        notifyLine4: '',
        notifyLine5: '',
        notifyLine6: '',
        notifyLine7: '',
        csrDepartment: 0,
        csrOffice: 0,
        dcDepartment: 0,
        dcOffice: 0,
        agentRefNo: '',
        customerId: 0,
        warehouseNo: '',
        shipper: '',
        consignee: '',
        notify: '',
        paymentData: '',
        carrierId: 0,
        vessel: '',
        voyageFlight: '',
        etd: null,
        paymentTermMBL: '',
        seaEQ: [],
        incoTerm: '',
        customerContact: '',
        measurements: '',
        loadingPortCode: '',
        transferPortCode: '',
        dischargingPortCode: '',
        destinationPortCode: '',
        quantityContract: 0,
        packing: '',
        cubageContract: 0,
        weightContract: 0,
        mark: '',
        cargoEnglishName: '',
        remarks: '',
        orderType: 0,
        containerLoadType: '',
        freightTerm: '',
        customerRefNo: '',
        cargoSource: '',
        arriveDate: null,
        customCutoff: null,
        customerCutoff: null,
        customerShutout: null,
        customerFileCutoff: null,
        csr: 0,
        dc: 0,
        scNo: '',
        insideQuantity: 0,
        insidePacking: '',
        chargeWeight: 0,
        cargoChineseName: '',
        userDefinedField1: '',
        userDefinedField2: '',
        userDefinedField3: '',
        userDefinedField4: '',
        sales: 0,
        op: 0,
        cargoType: '',
        salesOffice: 0,
        salesDepartment: 0,
        opOffice: 0,
        opDepartment: 0,
        bookingAgent: 0,
        vesselCode: '',
        ifContainSensitiveWord: false,
        novcc: '',
        tliNo: '',
        amount: 0,
        currency: '',
        customerReserveVoyage: '',
        userDefinedRoleId1: 0,
        userDefinedRoleId2: 0,
        overseaOp: 0,
        planner: 0,
        destinationAgent: 0,
        exChangeAgent: 0,
        carrierAgentId: 0,
        warehouseCmp: 0,
        warehouseName: '',
        customsBroker: 0,
        siteOP: 0,
        businessMark: [0],
        routeCode: '',
        soNo: '',
        mbl: '',
        carrierVoyage: '',
        portCode: '',
        shipperCode: '',
        shipperId: '',
        consigneeCode: '',
        consigneeId: '',
        notifyCode: '',
        notifyId: '',
        bookingTerm: 'OS' // 默认 自有约价
      },
      initJob: {
        shipperLine1: '',
        shipperLine2: '',
        shipperLine3: '',
        shipperLine4: '',
        shipperLine5: '',
        shipperLine6: '',
        shipperLine7: '',
        consigneeLine1: '',
        consigneeLine2: '',
        consigneeLine3: '',
        consigneeLine4: '',
        consigneeLine5: '',
        consigneeLine6: '',
        consigneeLine7: '',
        notifyLine1: '',
        notifyLine2: '',
        notifyLine3: '',
        notifyLine4: '',
        notifyLine5: '',
        notifyLine6: '',
        notifyLine7: '',
        csrDepartment: 0,
        csrOffice: 0,
        dcDepartment: 0,
        dcOffice: 0,
        agentRefNo: '',
        customerId: 0,
        warehouseNo: '',
        shipper: '',
        consignee: '',
        notify: '',
        paymentData: '',
        carrierId: 0,
        vessel: '',
        voyageFlight: '',
        etd: null,
        paymentTermMBL: '',
        seaEQ: [],
        incoTerm: '',
        customerContact: '',
        measurements: '',
        loadingPortCode: '',
        transferPortCode: '',
        dischargingPortCode: '',
        destinationPortCode: '',
        quantityContract: 0,
        packing: '',
        cubageContract: 0,
        weightContract: 0,
        mark: '',
        cargoEnglishName: '',
        remarks: '',
        orderType: 0,
        containerLoadType: '',
        freightTerm: '',
        customerRefNo: '',
        cargoSource: '',
        arriveDate: null,
        customCutoff: null,
        customerCutoff: null,
        customerShutout: null,
        customerFileCutoff: null,
        csr: 0,
        dc: 0,
        scNo: '',
        insideQuantity: 0,
        insidePacking: '',
        chargeWeight: 0,
        cargoChineseName: '',
        userDefinedField1: '',
        userDefinedField2: '',
        userDefinedField3: '',
        userDefinedField4: '',
        sales: 0,
        op: 0,
        cargoType: '',
        salesOffice: 0,
        salesDepartment: 0,
        opOffice: 0,
        opDepartment: 0,
        bookingAgent: 0,
        vesselCode: '',
        ifContainSensitiveWord: false,
        novcc: '',
        tliNo: '',
        amount: 0,
        currency: '',
        customerReserveVoyage: '',
        userDefinedRoleId1: 0,
        userDefinedRoleId2: 0,
        overseaOp: 0,
        planner: 0,
        destinationAgent: 0,
        exChangeAgent: 0,
        carrierAgentId: 0,
        warehouseCmp: 0,
        warehouseName: '',
        customsBroker: 0,
        siteOP: 0,
        businessMark: [0],
        routeCode: '',
        soNo: '',
        mbl: '',
        carrierVoyage: ''
      },
      OCR_FIELD_MAP,
      otherField: null,
      ocrRecognitionFields: [], // ocr识别字段
      ocrOtherFields: [], // 额外录单字段
      currentOcrRecognitionFields: [], // 当前 ocr识别字段
      currentOcrOtherFields: [], // 当前 额外录单字段
      fieldValidDialog: {
        visible: false,
        fieldValidResults: [] // 字段校验结果
      },
      fieldDefineMap: {}, // 字段定义
      firstEntry: true, // 首次进入时，字段、value框的颜色为默认值
      showBookRecognitionResults: false, // 展示托书识别结果
      vesselList: [], // 船名下拉列表
      showChooseShippingSchedulesBtn: false, // 显示【选择船期】 按钮
      voyageShowDialog: false,
      overseaAgentDataProviderChange: false, // 目的港代理数据源是否发生变更
      overseaAgentUsersList: [],
      warehouseNameList: [],
      incoTermZDList: ['FOB', 'EXW'], // 贸易条款 指定货
      incoTermZLList: ['FCA', 'CIF', 'DAP', 'DDU', 'DDP', 'CFR', 'CIP', 'CPT'], // 贸易条款 自揽货
      voyageShowDialogData: {
        etd: '',
        vesselId: '',
        voyageNo: '',
        loadingPortCode: '',
        transferPortCode: false,
        transfering: false,
        dischargingPortCode: '',
        routeCode: ''
      }
    }
  },
  computed: {
    isEcl() { // 海进委托拼箱
      return this.job.containerLoadType === 'ECL'
    },
    TYPE_NAMES() {
      return TYPE_NAMES
    },
    readOnly() {
      return this.details && this.details.status === 3
    },
    showOtherField() {
      return this.expressList && this.expressList.length > 0
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    config() {
      return this.context.config
    },
    columnDefs() {
      return [{
        headerName: '',
        colId: '',
        field: '',
        width: 65,
        headerCheckboxSelection: true,
        checkboxSelection: true,
        sortable: false,
        suppressMenu: true,
        suppressSizeToFit: true,
        resizable: false
      },
      {
        headerName: this.$t('SeaExport.ContainerNo'),
        colId: 'containerNo',
        field: 'containerNo',
        width: 200,
        editable: true,
        cellEditor: 'CargoAgGridCommonInputEditor'
      },
      {
        headerName: this.$t('SeaExport.ContainerSize'),
        field: 'eqSize',
        suppressMenu: true,
        lockVisible: true,
        cellRendererFramework: 'agGridColumnEdit',
        custom: {
          isEdit: true,
          tag: 'cargo-cell-select',
          optionField: {
            labelFunc: item => {
              let text = item.name
              if (text && (this.job.containerLoadType === 'BB' || (this.job && !this.job.masterFlag && !!this.job.lclMasterUuid && this.job.containerLoadType === 'BCF') || this.isEcl)) {
                text = 'PART OF ' + text
              }
              return text
            },
            value: 'code',
            filterable: false
          },
          attrs: {
            cellSelectAttrs: { fullOptions: [... this.eqSizes] }
          }
        }
      },
      {
        headerName: this.$t('SeaExport.ContainerType'),
        field: 'eqType',
        suppressMenu: true,
        cellRendererFramework: 'agGridColumnEdit',
        custom: {
          isEdit: true,
          tag: 'cargo-cell-select',
          optionField: {
            labelFunc: item => {
              return item.code
            },
            value: 'code',
            filterable: true
          },
          attrs: {
            cellSelectAttrs: { fullOptions: [... this.eqTypes] },
            style: 'width:70px'
          }
        }
      },
      {
        headerName: this.$t('SeaExport.SealNo'),
        colId: 'sealNo',
        field: 'sealNo',
        width: 200,
        editable: true,
        cellEditor: 'CargoAgGridCommonInputEditor'
      },
      {
        headerName: this.$t('SeaExport.Quantity'),
        colId: 'quantity',
        field: 'quantity',
        width: 100,
        cellStyle: (params) => {
          return ContainerUtil.containerPushDataStyleFunction2(params, 'quantity')
        },
        valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 0, true)),
        editable: true,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            precision: 0
          }
        }
      },
      {
        headerName: this.$t('SeaExport.GrossWeight'),
        colId: 'weight',
        field: 'weight',
        width: 100,
        cellStyle: (params) => {
          return ContainerUtil.containerPushDataStyleFunction2(params, 'weight')
        },
        valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
        editable: true,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            precision: 3
          }
        }
      },
      {
        headerName: this.$t('SeaExport.Package'),
        colId: 'packing',
        field: 'packing',
        width: 100,
        editable: true,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            selectType: TYPE_NAMES.basic_data_Packing,
            filterable: true,
            tagValue: 'code',
            customLabel: (item) => this.language === 'zh' ? `${item.chineseName}[${item.name}]` : `${item.name}[${item.chineseName}]`,
            showCustomLabelInOption: true
          }
        },
        valueFormatter: params => {
          return ColumnUtils.packingCodeLabelFun(params.value)
        }
      },
      {
        headerName: this.$t('SeaExport.Cubage'),
        colId: 'cubage',
        field: 'cubage',
        width: 100,
        cellStyle: (params) => {
          return ContainerUtil.containerPushDataStyleFunction2(params, 'cubage')
        },
        valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
        editable: true,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            precision: 3
          }
        }
      }]
    }
  },
  watch: {
    details(val, oldVal) {
      if (val.resultJson !== oldVal.resultJson) {
        this.init()
      }
    },
    index(val, oldVal) {
      if (val !== oldVal) {
        this.resultJson = this.resultArray[val].text.data
        this.job = this.resultJson.jobJson
        this.setDefaultValue()
        this.form = this.job
      }
    },
    'job.carrierId': {
      async handler(newVal) {
        this.shippingCompanySpecificCodeInvisible = false
        this.job.shippingCompanySpecificCode = ''
        if (newVal) {
          const company = await Company.getCompanyById(newVal)
          if (company) {
            if (company.chineseName === SystemConstants.RECEIPT_CARRIER_HMM.code || company.shortName === SystemConstants.RECEIPT_CARRIER_HMM.code ||
              company.englishName === SystemConstants.RECEIPT_CARRIER_HMM.code || company.cnShortName === SystemConstants.RECEIPT_CARRIER_HMM.code) {
              this.shippingCompanySpecificCodeInvisible = true
            }
          }
        }
      },
      immediate: true // 可选：是否在初始加载时立即执行
    }
  },
  async created() {
    await this.context.prepareData()
    this.pm.init()
    await cache.load(cacheName.CONFIG, cacheName.OFFICE)
    loadSpecificBasicInfo('Vessel').then(res => {
      this.vesselList = res.data
    }).catch(() => {
    })
    this.eqTypes = await getSpecificBasicData(basicCacheKeys.basic_data_EQType)
    queryShippingSchedule({ pageNum: 1, pageSize: 1, startDate: DateUtils.customFormat(new Date(), 'YYYY-MM-DD') }).then(res => {
      this.showChooseShippingSchedulesBtn = parseInt(res.data.total) > 0
    }).catch(() => {
    })
    await this.init()
  },
  methods: {
    handleFocus(val) {
      this.$emit('fieldFocus', val)
    },
    async init() {
      await this.initOcrSet()
      // 【已录单】的托书，字段展示历史的
      if (this.details.status === UPLOAD_STATUS_COMPLETE_ORDER.code && this.resultArray[0].ocrRecognitionFields && this.resultArray[0].ocrRecognitionFields.length > 0) {
        this.currentOcrRecognitionFields = this.resultArray[0].ocrRecognitionFields
        this.currentOcrOtherFields = this.resultArray[0].ocrOtherFields
      } else {
        this.currentOcrRecognitionFields = this.ocrRecognitionFields
        this.currentOcrOtherFields = this.ocrOtherFields
      }
      this.initOther()
      for (let i = 0; i < this.resultArray.length; ++i) {
        const result = this.resultArray[i]
        const resultJson = result.text.data
        const finalResultJson = this.getFinalResultJson(resultJson)
        // 将json信息转换成对应的值
        if (!resultJson.jobJson) {
          resultJson.jobJson = deepClone(this.initJob)
          resultJson.jobJson.index = i
          // 将finalResultJson赋值给jobJson
          Object.assign(resultJson.jobJson, finalResultJson)
          await this.initJobJson(resultJson.jobJson, finalResultJson)
          this.form = resultJson.jobJson
          // 初始化时，备份jobJson，用于统计准确率（业务保存成功，异步进行统计）
          resultJson.originJobJson = deepClone(resultJson.jobJson)
        } else {
          resultJson.jobJson.index = i
          this.form = resultJson.jobJson
        }
      }
      setTimeout(() => {
        this.resultJson = this.resultArray[this.index].text.data
        this.job = this.resultJson.jobJson
        this.form = this.job
        this.setDefaultValue()
        this.selectAllHandler()
        this.firstEntry = false
      }, 100)
    },
    // 根据【取值规则】组装finalResultJson
    getFinalResultJson(resultJson) {
      const finalResultJson = {}
      if (resultJson) {
        for (const fieldDetail of this.otherField.ocrOtherFieldDetails) {
          finalResultJson[fieldDetail.code] = resultJson[fieldDetail.code]
        }
      }
      return finalResultJson
    },
    // 默认选中全部
    selectAllHandler() {
      this.$nextTick(async() => {
        await ensureExecuteSuccess(() => this.gridApi)
        const gridApi = this.gridApi
        const nodes = gridApi.getRenderedNodes()
        if (nodes) {
          for (const node of nodes) {
            node.setSelected(node.data.selected || false)
          }
        }
      })
    },
    setDefaultValue() {
      let hasBusinessMark = false
      if (this.currentOcrOtherFields && this.currentOcrOtherFields.length > 0) {
        for (const item of this.currentOcrOtherFields) {
          if (item && item.code === SystemConstants.BUSINESS_MARK.code) {
            hasBusinessMark = true
            break
          }
        }
      }
      if (hasBusinessMark) {
        if (!this.job.businessMark || this.job.businessMark.length === 0) {
          this.job.businessMark = [0]
        }
      } else {
        this.job.businessMark = []
      }
    },
    async initJobJson(job, resultJson) {
      // 箱型、箱量
      this.setSeaEq(job, resultJson)
      this.setContainer(job, resultJson)
      this.convertMapper(job, resultJson)

      // 件数
      const quantityContract = this.changeValue(resultJson, 'quantityContract', ['CASE', 'PKGS', 'CTNS'])
      if (quantityContract !== 0) {
        job.quantityContract = Number(!StrUtils.isEmpty(job.packing) && typeof quantityContract === 'string' ? quantityContract.replace(job.packing, '') : quantityContract)
        job.quantityActual = job.quantityContract
      }
      // 毛重
      const weightContract = this.changeValue(resultJson, 'weightContract', ['KGS', this.$t('SeaExport.KG'), ','])
      job.weightContract = Number(weightContract)
      job.weightActual = job.weightContract
      // 体积
      const cubageContract = this.changeValue(resultJson, 'cubageContract', ['CBM', this.$t('SeaExport.CBM')])
      job.cubageContract = Number(cubageContract)
      job.cubageActual = job.cubageContract

      // 交货地 卸货港魏空时，互相赋值
      if (!job.destinationPortCode && job.dischargingPortCode) {
        job.destinationPortCode = job.dischargingPortCode
      } else if (!job.dischargingPortCode && job.destinationPortCode) {
        job.dischargingPortCode = job.destinationPortCode
      }

      // 货物类型识别为空时，默认“普货”
      if (!job.cargoType) {
        job.cargoType = CARGOTYPE_GENERAL.code
      }
      // 初始化 操作公司(一定要放在操作部门赋值前面，因为操作部门会根据操作分公司去查)
      job.opOffice = this.$store.getters.currentOfficeId
      // 初始化 操作
      if (!job.op) {
        job.op = this.$store.getters.userId
      }
      // 初始化 操作部门
      const user = await User.getUserById(job.op)
      if (user) {
        this.txtOPChangeHandler(user, job)
      }
      // 初始化【船舶呼号】
      if (job.vessel) {
        const currentVessel = this.vesselList.filter(p => p.englishName === job.vessel)[0]
        // 无值不清空
        if (currentVessel && currentVessel.callSign) {
          job.vesselCode = currentVessel.callSign
        }
      }
      job.lob = SI.code
      job.customs = true
      job.warehousing = true
      job.warehouseInfo = []
    },
    // 字段校验
    async fieldValid() {
      // 委托单位合同到期，不能创建业务校验
      const cmpIdxList = new Set()
      for (let i = 0; i < this.resultArray.length; ++i) {
        const jobJson = this.resultArray[i].text.data.jobJson
        if (jobJson.customerId) {
          cmpIdxList.add(jobJson.customerId)
        }
      }
      const contractExpiredCmpIdxList = []
      if (cmpIdxList.size > 0) {
        await isContractExpiredForbidCreateJobs(Array.from(cmpIdxList)).then(res => {
          if (res.data && res.data.length > 0) {
            contractExpiredCmpIdxList.push(...res.data)
          }
        })
      }
      if (this.otherField.ocrOtherFieldDetails && this.otherField.ocrOtherFieldDetails.length > 0) {
        const fieldValidResultsMap = new Map()
        // 必填项 校验
        const requiredFieldDetails = this.otherField.ocrOtherFieldDetails.filter(item => !!item.ifRequired && !!item.ifCheck)
        if (requiredFieldDetails && requiredFieldDetails.length > 0) {
          for (let i = 0; i < this.resultArray.length; ++i) {
            const result = this.resultArray[i]
            const fieldValidResultByBook = {
              index: i,
              data: []
            }
            const job = result.text.data.jobJson
            for (const fieldDetail of requiredFieldDetails) {
              // 保存业务必填校验、订舱必填校验
              if (fieldDetail.ifRequired.split(',').length > 1 || fieldDetail.ifRequired === OCR_FIELD_IF_REQUIRED_SAVE_JOB.code) {
                if (!job[fieldDetail.code] || (Array.isArray(job[fieldDetail.code]) && job[fieldDetail.code].length === 0)) {
                  fieldValidResultByBook.data.push({
                    fieldName: OcrUtils.getOcrFieldLabel(fieldDetail.code, this.useCase),
                    exceptionReason: this.$t('queryJob.CannotBeEmpty')
                  })
                } else if (fieldDetail.code === SystemConstants.OCR_FIELD_CUSTOMER_ID.code) {
                  if (contractExpiredCmpIdxList.indexOf(job[fieldDetail.code]) > -1) {
                    fieldValidResultByBook.data.push({
                      fieldName: OcrUtils.getOcrFieldLabel(fieldDetail.code, this.useCase),
                      exceptionReason: this.$t('Message.ContractExpireCannotCreated')
                    })
                  }
                }
              }
            }
            if (fieldValidResultByBook.data.length > 0) {
              // this.fieldValidDialog.fieldValidResults.push(fieldValidResultByBook)
              fieldValidResultsMap.set(i, fieldValidResultByBook)
            }
          }
        }
        // OCR-业务标记选择包含“转运”，点击【生成业务】判断中转港必填,未填写提示：请选择“中转港”
        for (let i = 0; i < this.resultArray.length; ++i) {
          const result = this.resultArray[i]
          const job = result.text.data.jobJson
          const fieldValidResultByBook = {
            index: i,
            data: []
          }
          if (job.businessMark && job.businessMark.includes(BUSINESS_MARK_1.code) && !job.transferPortCode) {
            fieldValidResultByBook.data.push({
              fieldName: this.$t('Payment.portOfTransfer'),
              exceptionReason: this.$t('CargoMsg.Cargo_PortOfTransferCheck')
            })
            if (fieldValidResultByBook.data.length > 0) {
              fieldValidResultsMap.set(i, fieldValidResultByBook)
            }
          }
        }

        if (fieldValidResultsMap.size > 0) {
          this.fieldValidDialog.fieldValidResults = Array.from(fieldValidResultsMap.values()).sort((a, b) => a.index - b.index)
          this.fieldValidDialog.visible = true
          return false
        }
      }
      return true
    },
    changeValue(job, targetField, replaceArr) {
      let result = 0
      if (!StrUtils.isEmpty(job[targetField])) {
        result = job[targetField]
        if (typeof result === 'string') {
          result = result.trim()
          for (const element of replaceArr) {
            result = result.replace(element, '')
          }
        }
      }
      return result
    },
    setSeaEq(job, resultJson) {
      try {
        job.seaEQ = []
        if (resultJson.seaEQ) {
          const dataArray = resultJson.seaEQ.split(',')
          for (const data of dataArray) {
            const cData = data.split(/[:]/g)
            const eqData = {}
            eqData.eqQuantity = 1
            if (cData.length > 1) {
              eqData.eqQuantity = Number(cData[1] || 1)
            }
            const match = cData[0].match(/^(\d+)([A-Za-z]+)/)
            if (match.length > 2) {
              eqData.eqSizeOrg = match[1]
              eqData.eqTypeOrg = match[2] && match[2].toUpperCase() === CONVERSION_HC.conversionValue ? CONVERSION_HC.originalValue : match[2]
            }
            const eqSize = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.local_cache_EQSize, 'code', eqData.eqSizeOrg, 'code')
            const eqType = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_EQType, 'code', eqData.eqTypeOrg, 'code')
            if (eqSize) {
              eqData.eqSize = eqSize
            }
            if (eqType) {
              eqData.eqType = eqType
            }
            job.seaEQ.push(eqData)
          }
        }
      } catch (e) {
        console.log('ResultFormSeCwmi error', e)
      }
    },
    setContainer(job, resultJson) {
      if (resultJson.container) {
        job.container = []
        for (const data of resultJson.container) {
          const c = {}
          c.eqSize = ''
          c.eqType = ''
          if (data.container_eqSize) {
            const match = data.container_eqSize.match(/^(\d+)([A-Za-z]+)/)
            c.eqSize = match[1]
            c.eqType = match[2] && match[2].toUpperCase() === CONVERSION_HC.conversionValue ? CONVERSION_HC.originalValue : match[2]
          }
          c.uuid = 'addResultJson__' + getUuid()
          c.selected = true
          c.containerNo = data.container_containerNo
          c.eqSizeStr = data.container_eqSize
          c.sealNo = data.container_sealNo
          c.quantity = data.container_quantity || 0
          c.packing = data.container_packing
          c.weight = data.container_weight || 0
          c.cubage = data.container_cubage || 0
          job.container.push(c)
        }
      }
    },
    initOther() {
      getSpecificBasicData(basicCacheKeys.basic_data_BlMode).then(data => {
        for (const item of data) {
          if (item.orderType === BlModeType.HBL.code) {
            const blMode = this.blModeList.find(p => p.uuid === item.uuid)
            if (!blMode) {
              this.blModeList.push(item)
            }
          }
        }
      })
    },
    convertMapper(job, resultJson) {
      this.initMapper()
      // 委托单位
      this.mapperCustomerId(job, resultJson)
      // 整箱拼箱
      this.mapperLoadType(job, resultJson)
      // 船公司
      this.mapperShipName(job, resultJson)
      // 开航日期
      this.mapperEtd(job, resultJson)
      // 运输条款
      this.mapperFreightTerm(job, resultJson)
      // 运费条款
      this.mapperPaymentTerm(job, resultJson)
      // 贸易条款
      this.mapperIncoTerm(job, resultJson)
      // 起运港
      this.mapperSeaPort('loadingPortCode', 'loadingPortCode', job, resultJson)
      // 中转港
      this.mapperSeaPort('transferPortCode', 'transferPortCode', job, resultJson)
      // 卸货港
      this.mapperSeaPort('dischargingPortCode', 'dischargingPortCode', job, resultJson)
      // 交货地
      this.mapperSeaPort('destinationPortCode', 'destinationPortCode', job, resultJson)
      // 包装
      this.mapperPacking('', job, resultJson, 'packing')
      // 小件包装
      this.mapperPacking('', job, resultJson, 'insidePacking')
      // 提单形式
      this.mapperOrderType(job, resultJson)
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0,
        autoHalfWord: false,
        autoUppercase: false
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    closeAdvanceText() {
      this.advanceTextDialog.visible = false
    },
    // 获取OCR映射
    async initOcrSet() {
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        anyInteger: SENDING_1.code, // 应用场景 1海运出口托书识别
        anyBool: true // 应用场景 判断是否应用总部
      }
      await getOcrList(params).then(res => {
        const ocrSet = res.data
        if (ocrSet) {
          // 额外录单字段
          this.toOtherField(ocrSet)
        }
      })
    },
    initMapper() {
      this.port = new Map()
      this.carrier = new Map()
      this.orderType = new Map()
      this.loadType = new Map()
      this.shippingTerm = new Map()
      this.paymentTerm = new Map()
      this.incoTerm = new Map()
      this.eq = new Map()
      this.customer = new Map()
      this.packing = new Map()
    },
    // 额外录单字段
    toOtherField(ocrSet) {
      this.otherField = ocrSet.finalField

      this.fieldDefineMap = ocrSet.fieldDefineMap
      if (this.otherField.ocrOtherFieldDetails) {
        // ocr识别字段
        this.ocrRecognitionFields = this.otherField.ocrOtherFieldDetails.filter(item => this.fieldDefineMap[item.code] && !this.fieldDefineMap[item.code].ifExtraField)
        // 额外录单字段
        this.ocrOtherFields = this.otherField.ocrOtherFieldDetails.filter(item => this.fieldDefineMap[item.code] && this.fieldDefineMap[item.code].ifExtraField)
      }
    },
    // 货物列表更改
    onGoodsCellChange() {

    },
    // 委托单位
    mapperCustomerId(job, resultJson) {
      job.customerId = 0
      if (!StrUtils.isEmpty(resultJson.customerId)) {
        // 用解析值 匹配 代码
        let customerId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'cnShortName', resultJson.customerId, 'cmpIdx')
        if (!customerId) {
          // 用解析值 匹配 英文名
          customerId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'englishName', resultJson.customerId, 'cmpIdx')
          if (!customerId || Number(customerId) <= 0) {
            // 用解析值 匹配 中文名
            customerId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'chineseName', resultJson.customerId, 'cmpIdx')
            if (!customerId || Number(customerId) <= 0) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_CUSTOMER.code + '_' + this.useCase + '_' + resultJson.customerId
              const newMapperVal = this.customer.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                customerId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'cnShortName', newMapperVal, 'cmpIdx')
                if (!customerId || Number(customerId) <= 0) {
                  // 用映射值 匹配 英文名
                  customerId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'englishName', newMapperVal, 'cmpIdx')
                  if (!customerId || Number(customerId) <= 0) {
                    // 用映射值 匹配 中文名
                    customerId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'chineseName', newMapperVal, 'cmpIdx')
                  }
                }
              }
            }
          }
        }
        job.customerId = customerId || 0
        // 委托单位 前缀模糊匹配
        if (!job.customerId) {
          namePrefixMatch({ companyName: resultJson.customerId }).then(res => {
            job.customerId = res.data
          })
        }
      }
    },
    // 船公司
    mapperShipName(job, resultJson) {
      job.carrierId = 0
      if (!StrUtils.isEmpty(resultJson.carrierId)) {
        // 用解析值 匹配 代码
        let carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'cnShortName', resultJson.carrierId, 'cmpIdx')
        carrierId = this.checkOfficeId(carrierId)
        if (!carrierId) {
          // 用解析值 匹配 英文名
          carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'englishName', resultJson.carrierId, 'cmpIdx')
          carrierId = this.checkOfficeId(carrierId)
          if (!carrierId || Number(carrierId) <= 0) {
            // 用解析值 匹配 中文名
            carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'chineseName', resultJson.carrierId, 'cmpIdx')
            carrierId = this.checkOfficeId(carrierId)
            if (!carrierId || Number(carrierId) <= 0) {
              // 用解析值 匹配 简称
              carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'shortName', resultJson.carrierId, 'cmpIdx')
              carrierId = this.checkOfficeId(carrierId)
              if (!carrierId || Number(carrierId) <= 0) {
                const mapperKey = SystemConstants.OCR_MAPPER_TYPE_CARRIER.code + '_' + this.useCase + '_' + resultJson.carrierId
                const newMapperVal = this.carrier.get(mapperKey)
                if (newMapperVal) {
                  // 用映射值 匹配 代码
                  carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'cnShortName', newMapperVal, 'cmpIdx')
                  carrierId = this.checkOfficeId(carrierId)
                  if (!carrierId || Number(carrierId) <= 0) {
                    // 用映射值 匹配 英文名
                    carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'englishName', newMapperVal, 'cmpIdx')
                    carrierId = this.checkOfficeId(carrierId)
                    if (!carrierId || Number(carrierId) <= 0) {
                      // 用映射值 匹配 中文名
                      carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'chineseName', newMapperVal, 'cmpIdx')
                      carrierId = this.checkOfficeId(carrierId)
                      if (!carrierId || Number(carrierId) <= 0) {
                        // 用映射值 匹配 简称
                        carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'shortName', newMapperVal, 'cmpIdx')
                        carrierId = this.checkOfficeId(carrierId)
                      }
                    }
                  }
                }
              }
            }
          }
        }
        job.carrierId = carrierId || 0
      }
    },
    checkOfficeId(carrierId) {
      if (carrierId && carrierId > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', carrierId)
        if (company && (!company.seaCmp || !company.active || (company.branchId !== 1 && company.branchId !== this.$store.getters.currentOfficeId &&
          (!company.multipleBranchId || (company.multipleBranchId && !company.multipleBranchId.split(',').includes(String(this.$store.getters.currentOfficeId))))))) {
          carrierId = 0
        }
      }
      return carrierId
    },
    mapperEtd(job, resultJson) {
      let etdStr = resultJson.etd
      // 开航日期无年份，则默认当前年份
      if (etdStr && etdStr.length > 4) {
        const years = etdStr.substring(0, 4)
        if (!isNumber(years)) {
          etdStr = new Date().getFullYear() + '-' + etdStr
        }
      }
      if (etdStr) {
        etdStr = etdStr.replaceAll(/[年月日号.]/g, '-')
        let etd = DateUtils.toDateStr(etdStr)
        if (!etd && etdStr.length > 8) {
          etd = ColumnUtils.dateTimeLabelFunc(etdStr)
        }
        job.etd = etd || ''
      }
    },
    // 整箱拼箱
    mapperLoadType(job, resultJson) {
      if (!StrUtils.isEmpty(resultJson.containerLoadType)) {
        // 用解析值 匹配 代码
        let loadType = CommonState.getStateByCode(_cargoTypeInputList, resultJson.containerLoadType)
        let loadTypeCode = loadType ? loadType.code : ''
        if (!loadTypeCode) {
          // 用解析值 匹配 中英文名
          loadType = ContainerLoadType.queryContainerLoadTypeByName(resultJson.containerLoadType, _cargoTypeInputList)
          loadTypeCode = loadType ? loadType.code : ''
        }
        job.containerLoadType = loadTypeCode || ''
      }
    },
    // 运输条款
    mapperFreightTerm(job, resultJson) {
      if (!StrUtils.isEmpty(resultJson.freightTerm)) {
        // 用解析值 匹配 代码
        let freightTerm = ColumnUtils.resolveColumnLabelFreightTerm(TYPE_NAMES.basic_data_ShippingTerm, 'code', resultJson.freightTerm, 'code')
        if (!freightTerm) {
          // 用解析值 匹配 英文名
          freightTerm = ColumnUtils.resolveColumnLabelFreightTerm(TYPE_NAMES.basic_data_ShippingTerm, 'name', resultJson.freightTerm, 'code')
          if (!freightTerm) {
            // 用解析值 匹配 中文名
            freightTerm = ColumnUtils.resolveColumnLabelFreightTerm(TYPE_NAMES.basic_data_ShippingTerm, 'localName', resultJson.freightTerm, 'code')
            if (!freightTerm) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_SHIPPING_TERM.code + '_' + this.useCase + '_' + resultJson.freightTerm
              const newMapperVal = this.shippingTerm.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                freightTerm = ColumnUtils.resolveColumnLabelFreightTerm(TYPE_NAMES.basic_data_ShippingTerm, 'code', newMapperVal, 'code')
                if (!freightTerm) {
                  // 用映射值 匹配 英文名
                  freightTerm = ColumnUtils.resolveColumnLabelFreightTerm(TYPE_NAMES.basic_data_ShippingTerm, 'name', newMapperVal, 'code')
                  if (!freightTerm) {
                    // 用映射值 匹配 中文名
                    freightTerm = ColumnUtils.resolveColumnLabelFreightTerm(TYPE_NAMES.basic_data_ShippingTerm, 'localName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        job.freightTermMBL = freightTerm || ''
        job.freightTerm = freightTerm || ''
      }
    },
    // 运费条款
    mapperPaymentTerm(job, resultJson) {
      if (!StrUtils.isEmpty(resultJson.paymentTermMBL)) {
        // if (['PP', 'PREPAID'].indexOf(resultJson.paymentTerm.toUpperCase()) > -1) {
        //   resultJson.paymentTerm = 'FREIGHT PREPAID'
        // } else if (['CC', 'COLLECT'].indexOf(resultJson.paymentTerm.toUpperCase()) > -1) {
        //   resultJson.paymentTerm = 'FREIGHT COLLECT'
        // }
        // 用解析值 匹配 代码
        let paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'code', resultJson.paymentTermMBL, 'code')
        if (!paymenTerm) {
          // 用解析值 匹配 英文名
          paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'name', resultJson.paymentTermMBL, 'code')
          if (!paymenTerm) {
            // 用解析值 匹配 中文名
            paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'localName', resultJson.paymentTermMBL, 'code')
            if (!paymenTerm) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PAYMENT_TERM.code + '_' + this.useCase + '_' + resultJson.paymentTermMBL
              const newMapperVal = this.paymentTerm.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'code', newMapperVal, 'code')
                if (!paymenTerm) {
                  // 用映射值 匹配 英文名
                  paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'name', newMapperVal, 'code')
                  if (!paymenTerm) {
                    // 用映射值 匹配 中文名
                    paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'localName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        // job.paymentTermHBL = paymenTerm || ''
        job.paymentTermMBL = paymenTerm || ''
      }
    },
    // 贸易条款
    mapperIncoTerm(job, resultJson) {
      if (!StrUtils.isEmpty(resultJson.incoTerm)) {
        // const cifRegex = /\b(CIF)\b/g
        // const fobRegex = /\b(FOB)\b/g
        // const dapRegex = /\b(DAP)\b/g
        // if (cifRegex.test(resultJson.incoTerm)) {
        //   resultJson.incoTerm = 'CIF'
        // } else if (fobRegex.test(resultJson.incoTerm)) {
        //   resultJson.incoTerm = 'FOB'
        // } else if (dapRegex.test(resultJson.incoTerm)) {
        //   resultJson.incoTerm = 'DAP'
        // }
        // 用解析值 匹配 代码
        let incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'code', resultJson.incoTerm, 'code')
        if (!incoTerm) {
          // 用解析值 匹配 英文名
          incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'name', resultJson.incoTerm, 'code')
          if (!incoTerm) {
            // 用解析值 匹配 中文名
            incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'localName', resultJson.incoTerm, 'code')
            if (!incoTerm) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_INCO_TERM.code + '_' + this.useCase + '_' + resultJson.incoTerm
              const newMapperVal = this.incoTerm.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'code', newMapperVal, 'code')
                if (!incoTerm) {
                  // 用映射值 匹配 英文名
                  incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'name', newMapperVal, 'code')
                  if (!incoTerm) {
                    // 用映射值 匹配 中文名
                    incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'localName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        job.incoTerm = incoTerm || ''
      }
    },
    // 起运港 中转港 卸货港 交货地
    mapperSeaPort(code = '', jsonCode = '', job, resultJson) {
      if (!code) return
      if (!resultJson[jsonCode]) return
      // 用解析值 匹配 代码
      let portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'code', resultJson[jsonCode], 'code')
      if (!portCode) {
        // 用解析值 匹配 英文名
        portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'englishName', resultJson[jsonCode], 'code')
        if (!portCode) {
          // 用解析值 匹配 中文名
          portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'chineseName', resultJson[jsonCode], 'code')
          if (!portCode) {
            const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PORT.code + '_' + this.useCase + '_' + resultJson[jsonCode]
            const newMapperVal = this.port.get(mapperKey)
            if (newMapperVal) {
              // 用映射值 匹配 代码
              portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'code', newMapperVal, 'code')
              if (!portCode) {
                // 用映射值 匹配 英文名
                portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'englishName', newMapperVal, 'code')
                if (!portCode) {
                  // 用映射值 匹配 中文名
                  portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'chineseName', newMapperVal, 'code')
                }
              }
            }
          }
        }
      }
      // 只比较','前面的部分；比如：shanghai 匹配 shanghai,china
      // if (!portCode) {
      //   // 用解析值 匹配 代码
      //   portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'code', resultJson[jsonCode], 'code', null, true)
      //   if (!portCode) {
      //     // 用解析值 匹配 英文名
      //     portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'englishName', resultJson[jsonCode], 'code', null, true)
      //     if (!portCode) {
      //       // 用解析值 匹配 中文名
      //       portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'chineseName', resultJson[jsonCode], 'code', null, true)
      //     }
      //   }
      // }
      // CARGO-49588 如果完全匹配没有匹配得上 那就以逗号分割,只要匹配得上，后面就不匹配了
      if (!portCode) {
        // 将中文逗号替换成英文逗号
        const replacedString = resultJson[jsonCode].replace(/，/g, ',')
        // 将字符串按英文逗号分割成数组
        const splitArray = replacedString.split(',')
        // 遍历数组
        for (let i = 0; i < splitArray.length; i++) {
          portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'code', splitArray[i], 'code')
          if (!portCode) {
            // 用解析值 匹配 英文名
            portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'englishName', splitArray[i], 'code')
            if (!portCode) {
              // 用解析值 匹配 中文名
              portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'chineseName', splitArray[i], 'code')
              if (!portCode) {
                const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PORT.code + '_' + this.useCase + '_' + splitArray[i]
                const newMapperVal = this.port.get(mapperKey)
                if (newMapperVal) {
                  // 用映射值 匹配 代码
                  portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'code', newMapperVal, 'code')
                  if (!portCode) {
                    // 用映射值 匹配 英文名
                    portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'englishName', newMapperVal, 'code')
                    if (!portCode) {
                      // 用映射值 匹配 中文名
                      portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'chineseName', newMapperVal, 'code')
                    } else {
                      break
                    }
                  } else {
                    break
                  }
                }
              } else {
                break
              }
            } else {
              break
            }
          } else {
            break
          }
        }
      }
      job[code] = portCode || ''
    },
    // 包装
    mapperPacking(packingVal = '', job, resultJson, name) {
      let realPacking = resultJson[name]
      if (packingVal) { // 多单模式时 packingVal 有值
        realPacking = packingVal
      }
      let packingCode = ''
      if (!StrUtils.isEmpty(realPacking)) {
        // 用解析值 匹配 代码
        packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'code', realPacking, 'code')
        if (!packingCode) {
          // 用解析值 匹配 英文名
          packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'name', realPacking, 'code')
          if (!packingCode) {
            // 用解析值 匹配 中文名
            packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'chineseName', realPacking, 'code')
            if (!packingCode) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PACKING.code + '_' + this.useCase + '_' + realPacking
              const newMapperVal = this.packing.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'code', newMapperVal, 'code')
                if (!packingCode) {
                  // 用映射值 匹配 英文名
                  packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'name', newMapperVal, 'code')
                  if (!packingCode) {
                    // 用映射值 匹配 中文名
                    packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'chineseName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        if (!packingVal) { // 多单模式时 packingVal 有值
          job[name] = packingCode || ''
        }
      }
      return packingCode
    },
    // 提单形式 ORIGINAL 正本 1/SURRENDERED 电放 2/SEA WAYBILL 电放 3
    mapperOrderType(job, resultJson) {
      job.orderType = null
      if (!StrUtils.isEmpty(resultJson.orderType)) {
        let releaseType = null
        const orderType = resultJson.orderType
        if (orderType === 'ORIGINAL') {
          releaseType = 1
        } else if (orderType === 'SURRENDERED') {
          releaseType = 2
        } else if (orderType === 'SEA WAYBILL') {
          releaseType = 3
        } else {
          releaseType = ColumnUtils.getBlModeSerialNumberByName(orderType)
        }
        if (releaseType) {
          const mapperKey = SystemConstants.OCR_MAPPER_TYPE_BL_TYPE.code + '_' + this.useCase + '_' + resultJson.orderType
          const newMapperVal = this.orderType.get(mapperKey)
          if (newMapperVal) {
            // 用映射值 匹配 中英文名
            releaseType = ColumnUtils.getBlModeSerialNumberByName(newMapperVal)
          }
        }

        job.orderType = releaseType
      }
    },
    etdChange(value) {
      this.job.etd = value
    },
    // 保存时获取数据
    getSubmitData() {
      const result = this.resultJson
      result.jobJson = this.job
      return result
    },
    // 客服改变
    async csrChangeHandler(data) {
      const job = this.job
      job.csr = data.value
      job.csrDepartment = 0
      job.csrOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'csr', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.$store.getters.currentOfficeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.csrOffice = office ? office.officeId : 0
              job.csrDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'csr')
          if (dep) {
            job.csrDepartment = dep.departmentId
            const office = await Office.getOfficeByUuid(dep.officeUuid)
            job.csrOffice = office ? office.officeId : 0
          }
        }
      }
    },
    changeSizeCallBack(item, p) {
      item.eqSizeOrg = item.eqSize = p.value
    },
    changeTypeCallBack(item, p) {
      item.eqTypeOrg = item.eqType = p.value
    },
    // 单证改变
    async dcChangeHandler(data) {
      const job = this.job
      job.dc = data.value
      job.dcDepartment = 0
      job.dcOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'doc', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.$store.getters.currentOfficeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.dcOffice = office ? office.officeId : 0
              job.dcDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'doc')
          job.dcDepartment = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.dcOffice = office ? office.officeId : 0
        }
      } else {
        job.dc = 0
        job.dcDepartment = 0
        job.dcOffice = 0
      }
    },
    /**
     * 操作改变
     */
    txtOPChangeHandler(user, job) {
      // const job = this.job
      if (user.defaultDepId > 0) {
        job.opDepartment = user.defaultDepId
      } else {
        if (job.opOffice > 0) {
          new User(user).getUserDefaultDepartmentByOffice('role', 'op', job.opOffice).then(dep => {
            job.opDepartment = dep ? dep.departmentId : 0
          })
        } else {
          new User(user).getDefaultDepartment('role', 'op', job.opOffice).then(dep => {
            job.opDepartment = dep ? dep.departmentId : 0
          })
        }
      }
    },
    getFieldColor(item) {
      if (!this.firstEntry && item.ifCheck && item.ifRequired) {
        if (item.ifRequired.split(',').length > 1 || item.ifRequired === OCR_FIELD_IF_REQUIRED_SAVE_JOB.code) {
          return '#1398f1'
        }
      }
      return '#8c8d8e'
    },
    getValueBorderColor(item) {
      // console.log('getValueBorderColor, code:', item.code)
      if (!this.firstEntry && item.ifCheck && item.ifRequired) {
        if (item.ifRequired.split(',').length > 1 || item.ifRequired === OCR_FIELD_IF_REQUIRED_SAVE_JOB.code) {
          if (!this.job[item.code] || (Array.isArray(this.job[item.code]) && this.job[item.code].length === 0)) {
            return 'red'
          }
        }
      }
      return this.fieldDefineMap[item.code] && this.fieldDefineMap[item.code].ifExtraField ? 'white' : '#cee0c8'
    },
    // 新增 箱型箱量
    addSeaEQ() {
      this.job.seaEQ.push({})
    },
    addContainer() {
      if (!this.job.container) {
        this.job.container = []
      }
      const c = {}
      c.eqSize = ''
      c.eqType = ''
      c.uuid = 'addResultJson__' + getUuid()
      c.chargeSource = true
      c.containerNo = ''
      c.eqSizeStr = ''
      c.sealNo = ''
      c.quantity = 0
      c.packing = ''
      c.weight = 0
      c.cubage = 0
      c.selected = false
      this.job.container.push(c)
      this.selectAllHandler()
    },
    deleteContainer() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      // 从 container 中移除选中项
      this.job.container = this.job.container.filter(item => !selectedRows.includes(item))
    },
    // 删除 箱型箱量
    deleteSeaEQ(index) {
      this.job.seaEQ.splice(index, 1)
    },
    // 船名变更调整
    async onVesselSelectionChange(data) {
      this.job.vessel = data.value
      // 无值不清空
      if (data.callSign) {
        this.job.vesselCode = data.callSign
      }
    },
    // 打开【选中船期】弹框
    btnVayageShowHandle() {
      this.voyageShowDialog = true
      // etd
      this.voyageShowDialogData.etd = this.job.etd
      // 船名
      this.voyageShowDialogData.vesselId = this.job.vessel
      // 航次
      this.voyageShowDialogData.voyageNo = this.job.voyageFlight
      // 装货港/起运港
      this.voyageShowDialogData.loadingPortCode = this.job.loadingPortCode
      this.voyageShowDialogData.transfering = this.job.transfering
      // 勾选了中转 就将中转港设置为卸货港
      if (this.job.transfering) {
        // 中转港
        this.voyageShowDialogData.dischargingPortCode = this.job.transferPortCode
      } else {
        // 卸货港
        this.voyageShowDialogData.dischargingPortCode = this.job.dischargingPortCode
      }
      // 页面来源：不展示【只看国际航线】、显示【船公司】 高级查询
      this.voyageShowDialogData.pageSource = 'ocr'
      // 船公司
      this.voyageShowDialogData.carrierId = this.job.carrierId
      this.$refs.voyageShowDialog.onshow(this.voyageShowDialogData)
    },
    // 【选中船期】选中回调处理
    callbackShippingScheduleHanle(param) {
      // 弹窗关闭
      this.voyageShowDialog = false
      // 船名
      if (param.englishName) {
        this.job.vessel = param.englishName
      }
      // 航次
      if (param.voyageNo) {
        this.job.voyageFlight = param.voyageNo
      }
      // 船舶呼号
      if (param.callSign) {
        this.job.vesselCode = param.callSign
      }
      // etd
      if (param.etd) {
        this.job.etd = param.etd
      }
      // 船公司
      if (param.carrierId) {
        this.job.carrierId = param.carrierId
      }
    },
    clear(item) {
      this.resultJson[item.code + '_notShowPlaceholder'] = true
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
.result-form-se {
  display: flex;

  .row {
    display: flex;
    align-items: stretch
  }

  .item1 {
    min-width: 100px;
    border: 1px solid white;
    background-color: #e9edf1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
  }

  .item2 {
    width: 100%;
    min-width: 100px;
    border: 1px solid white;
    background-color: #f7f7f7;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
    pointer-events: none;
  }

  .item3 {
    width: 100%;
    border: 1px solid #cee0c8;
    background-color: #cee0c8;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;

    /deep/ input.el-input__inner {
      background-color: #cee0c8;
      text-align: left;
    }

    .item3-1 /deep/ input.el-input__inner {
      background-color: white;
    }

    /deep/ .el-textarea__inner {
      background-color: #cee0c8;
    }
  }

  .item4 {
    width: 100%;
    border: 1px solid white;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;

    /deep/ input.el-input__inner {
      background-color: white;
    }

    /deep/ .el-textarea__inner {
      background-color: white;
    }
  }

  .color-yellow {
    /deep/ textarea.el-textarea__inner {
      color: #e36402;
    }
  }

  .is-require {
    color: #4abff3;
  }

  .color-red {
    /deep/ input::placeholder {
      color: red !important;
    }
  }
}
</style>
